// @flow

import BaseChannel from './BaseChannel';

export default class LegacyPrivateAccountChannel extends BaseChannel {
  static channelName = "LegacyPrivateAccountChannel"
}
